import React from 'react'
import './app.css'
import { Routers } from './router'
function App() {
  return (
    <div className="app">
      <Routers />
    </div>
  )
}

export default App
